import { z } from 'zod';
import { USER_GROUP_CONSTRAINTS } from './constraints.js';
export const userGroupCreateFormSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, `${USER_GROUP_CONSTRAINTS.name.label} is required.`)
        .max(USER_GROUP_CONSTRAINTS.name.maxLength),
    description: z.string().max(USER_GROUP_CONSTRAINTS.description.maxLength),
});
//# sourceMappingURL=create-form.js.map